import { createAction } from 'typesafe-actions';
import { ActivityExportEntitlementNFTType } from '@block-explorer/entities';

export const setActivityExportEntitlementNFT = createAction(
  'SET_ENTITLEMENT_NFT'
)<ActivityExportEntitlementNFTType[] | null>();
